import { createContext } from "react";
import useAgentPersonnelSummaries from "../hooks/data/useAgentPersonnelSummaries";

export interface IUserAgentLocationSummariesContext extends ReturnType<typeof useAgentPersonnelSummaries> {

};

const UserAgentLocationSummariesContext = createContext<IUserAgentLocationSummariesContext>({
    data: undefined,
    error: undefined,
    loading: true,
    validating: true,
    mutate: async () => { return undefined },
    refresh: async () => { return undefined },
});

export default UserAgentLocationSummariesContext